import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/footer";

/* ---- Brand colors ---- */
const BRAND = "#4CB1A1";
const BRAND_HOVER = "#2B8D80";

/* ---- ICONS ---- */
const Icons = {
  info: (cls = "") => (
    <svg className={cls} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
      <path fillRule="evenodd" d="M8 0a4 4 0 0 1 4 4v2.05a2.5 2.5 0 0 1 2 2.45v5A2.5 2.5 0 0 1 11.5 16h-7A2.5 2.5 0 0 1 2 13.5v-5a2.5 2.5 0 0 1 2-2.45V4a4 4 0 0 1 4-4m0 1a3 3 0 0 0-3 3v2h6V4a3 3 0 0 0-3-3"/>
    </svg>
  ),
  personVcard: (cls = "") => (
    <svg className={cls} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
      <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm4.5 0a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6m5 2.755C12.146 12.825 10.623 12 8 12s-4.146.826-5 1.755V14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1z"/>
    </svg>
  ),
  checkCircle: (cls = "") => (
    <svg className={cls} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
      <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/>
    </svg>
  ),
  databaseDown: (cls = "") => (
    <svg className={cls} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
      <path d="M1 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm5-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1z"/>
    </svg>
  ),
  shieldLock: (cls = "") => (
    <svg className={cls} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
      <path d="M5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.8 11.8 0 0 1-2.517 2.453 7 7 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7 7 0 0 1-1.048-.625 11.8 11.8 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 63 63 0 0 1 5.072.56"/>
    </svg>
  ),
  cookie: (cls = "") => (
    <svg className={cls} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
      <path d="M8 0a8 8 0 1 0 8 8c0-.55-.045-1.086-.132-1.607A2 2 0 0 1 13.5 4.5a2 2 0 0 1-2-2A2 2 0 0 1 9 0.132 8.1 8.1 0 0 0 8 0M5.5 6A1.5 1.5 0 1 1 7 7.5 1.5 1.5 0 0 1 5.5 6m5 1a1 1 0 1 1-1 1 1 1 0 0 1 1-1M6 10a1 1 0 1 1-1 1 1 1 0 0 1 1-1"/>
    </svg>
  ),
  fileText: (cls = "") => (
    <svg className={cls} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
      <path d="M4 0h5l3 3v13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"/><path fill="#fff" d="M9 3V0l3 3z"/><path fill="#fff" d="M5 6h6v1H5zm0 2h6v1H5zm0 2h4v1H5z"/>
    </svg>
  ),
  share: (cls = "") => (
    <svg className={cls} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
      <path d="M1.92.506a.5.5 0 0 1 .434.14L3 1.293l.646-.647a.5.5 0 0 1 .708 0L5 1.293l.646-.647a.5.5 0 0 1 .708 0L7 1.293l.646-.647a.5.5 0 0 1 .708 0L9 1.293l.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .708 0l.646.647.646-.647a.5.5 0 0 1 .801.13l.5 1A.5.5 0 0 1 15 2v12a.5.5 0 0 1-.053.224l-.5 1a.5.5 0 0 1-.8.13L13 14.707l-.646.647a.5.5 0 0 1-.708 0L11 14.707l-.646.647a.5.5 0 0 1-.708 0L9 14.707l-.646.647a.5.5 0 0 1-.708 0L7 14.707l-.646.647a.5.5 0 0 1-.708 0L5 14.707l-.646.647a.5.5 0 0 1-.708 0L3 14.707l-.646.647a.5.5 0 0 1-.801-.13l-.5-1A.5.5 0 0 1 1 14V2a.5.5 0 0 1 .053-.224l.5-1a.5.5 0 0 1 .367-.27"/>
      <path d="M3 4.5h6a.5.5 0 1 1 0 1H3a.5.5 0 0 1 0-1m0 2h6a.5.5 0 1 1 0 1H3a.5.5 0 0 1 0-1m0 2h6a.5.5 0 1 1 0 1H3a.5.5 0 0 1 0-1m0 2h6a.5.5 0 1 1 0 1H3a.5.5 0 0 1 0-1m8-6h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1m0 2h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1m0 2h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1m0 2h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1"/>
    </svg>
  ),
  pen: (cls = "") => (
    <svg className={cls} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
    </svg>
  ),
  repeat: (cls = "") => (
    <svg className={cls} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
      <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9"/>
      <path fillRule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"/>
    </svg>
  ),
  chatText: (cls = "") => (
    <svg className={cls} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
      <path d="M2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
    </svg>
  ),
  image: (cls = "") => (
    <svg className={cls} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
      <path d="M14 2H2a2 2 0 0 0-2 2v8l3-3 3 3 3-3 5 5V4a2 2 0 0 0-2-2z"/>
      <circle cx="5" cy="5" r="1.5" fill="#fff"/>
    </svg>
  ),
  boxArrowInRight: (cls = "") => (
    <svg className={cls} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
      <path d="M6 3.5a.5.5 0 0 1 .5-.5H12V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1H6.5a.5.5 0 0 1 0-1H12v-1H6.5a.5.5 0 0 1 0-1H12V7H6.5a.5.5 0 0 1 0-1H12V4H6.5a.5.5 0 0 1-.5-.5"/>
      <path d="M15.354 8.354a.5.5 0 0 0 0-.708L13.172 5.464a.5.5 0 1 0-.707.707L14.086 8l-1.621 1.829a.5.5 0 1 0 .707.707z"/>
    </svg>
  ),
  graphUp: (cls = "") => (
    <svg className={cls} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
      <path d="M8.473.337a.5.5 0 0 0-.946 0L6.954 2H2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h1.85l-1.323 3.837a.5.5 0 1 0 .946.326L4.908 11H7.5v2.5a.5.5 0 0 0 1 0V11h2.592l1.435 4.163a.5.5 0 0 0 .946-.326L12.15 11H14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H9.046z"/>
    </svg>
  ),
  shieldCheck: (cls = "") => (
    <svg className={cls} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
      <path d="M5.072 1.106 8 .051l2.928 1.055A2 2 0 0 1 12 3.02V6.5c0 2.99-1.507 5.224-3.885 6.82a1.9 1.9 0 0 1-2.23 0C3.507 11.724 2 9.49 2 6.5V3.02a2 2 0 0 1 3.072-1.914"/>
      <path fill="#fff" d="M6.97 8.97 8.5 10.5l2.53-2.53.707.707L8.5 12 6.263 9.763z"/>
    </svg>
  ),
};

/* ---- SECTIONS ---- */
const SECTIONS = [
  { id: "overview", title: "Privacy Policy", icon: "info" },
  { id: "identity", title: "Identity of the responsible", icon: "personVcard" },
  { id: "principles", title: "Principles we will apply to your personal information", icon: "checkCircle" },
  { id: "data-source", title: "How did we get your data?", icon: "databaseDown" },
  { id: "rights", title: "What are your rights when you provide us with your data?", icon: "shieldCheck" },
  { id: "purposes", title: "For what purpose do we process your personal data?", icon: "fileText" },
  { id: "protection", title: "How do we protect your data", icon: "shieldLock" },
  { id: "cookies", title: "Cookies", icon: "cookie" },
  { id: "legal-basis", title: "Legitimation, data categories and retention", icon: "fileText" },
  { id: "recipients", title: "Recipients, web browsing & analytics", icon: "share" },
  { id: "accuracy", title: "Accuracy, acceptance/consent & revocation", icon: "pen" },
  { id: "changes", title: "Changes in the privacy policy", icon: "repeat" },
  { id: "about", title: "About us", icon: "info" },
  { id: "collected", title: "What personal data do we collect and why", icon: "fileText" },
  { id: "comments", title: "Comments", icon: "chatText" },
  { id: "media", title: "Media", icon: "image" },
  { id: "forms-cookies", title: "Contact forms & cookies", icon: "cookie" },
  { id: "embedded", title: "Embedded content from other websites", icon: "boxArrowInRight" },
  { id: "analytics-sharing", title: "Analytics / who we share data with / how long we keep it", icon: "graphUp" },
  { id: "rights-over-data", title: "What rights do you have over your data?", icon: "shieldCheck" },
];


export default function PrivacyPolicy() {
  const tocRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const links = Array.from(tocRef.current?.querySelectorAll("a[data-id]") || []);
    const ids = links.map((a) => a.getAttribute("data-id"));
    const sections = ids.map((id) => document.getElementById(id)).filter(Boolean);

    // Marca o ativo pelo IntersectionObserver…
    const io = new IntersectionObserver(
      (entries) => {
        const vis = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0]?.target.id;
        if (vis) {
          links.forEach((a) =>
            a.setAttribute("aria-current", a.getAttribute("data-id") === vis ? "true" : "false")
          );
        }
      },
      // sensível: ativa por volta de 30% do card
      { rootMargin: "-30% 0px -60% 0px", threshold: [0, 0.15, 0.3, 0.6, 1] }
    );
    sections.forEach((s) => io.observe(s));

    // …mas garante o ÚLTIMO quando chegas ao fundo (caso não haja mais scroll)
    const onScroll = () => {
      const scrolled = window.scrollY + window.innerHeight;
      const max = document.documentElement.scrollHeight;
      if (scrolled >= max - 4) {
        const lastId = ids[ids.length - 1];
        links.forEach((a) =>
          a.setAttribute("aria-current", a.getAttribute("data-id") === lastId ? "true" : "false")
        );
      }
      if (window.scrollY <= 2) {
        const firstId = ids[0];
        links.forEach((a) =>
          a.setAttribute("aria-current", a.getAttribute("data-id") === firstId ? "true" : "false")
        );
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });

    // Click -> scroll suave + flash 
    const onClick = (e) => {
      const id = e.currentTarget.getAttribute("data-id");
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      target.classList.add("ring-4", "ring-[color:rgba(13,148,136,0.25)]", "transition-shadow", "duration-700");
      setTimeout(() => {
        target.classList.remove("ring-4", "ring-[color:rgba(13,148,136,0.25)]");
      }, 800);
    };
    links.forEach((a) => a.addEventListener("click", onClick));

    return () => {
      io.disconnect();
      window.removeEventListener("scroll", onScroll);
      links.forEach((a) => a.removeEventListener("click", onClick));
    };
  }, []);

  // tamanhos consistentes dos ícones
const iconMenuCls = "w-4 h-4 flex-none";
  const iconCardCls = "w-5 h-5";

  const brandLinkCls = `underline underline-offset-2 decoration-transparent hover:decoration-current transition-colors text-[${BRAND}] hover:text-[${BRAND_HOVER}]`;

  const Card = ({ id, title, icon, children }) => (
    <section
      id={id}
      className="
        bg-white border border-slate-200 rounded-xl shadow-sm p-5 sm:p-6 mb-5
        scroll-mt-28
      "
    >
      <h2 className="flex items-center gap-3 text-slate-900 font-semibold text-lg">
        <span className="inline-flex h-8 w-8 items-center justify-center rounded-md bg-teal-50 text-teal-600">
          {Icons[icon](iconCardCls)}
        </span>
        {title}
      </h2>
      <div className="mt-3 text-slate-700 leading-relaxed">{children}</div>
    </section>
  );

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Back arrow */}
      <button
        type="button"
        onClick={() => window.history.length > 1 ? navigate(-1) : navigate("/")}
        className="fixed left-5 top-6 z-50 flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white/60 backdrop-blur transition hover:border-[#38c8ba]/40 hover:text-[#38c8ba] sm:left-8 sm:top-8"
        aria-label="Voltar"
      >
        <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M17 10a.75.75 0 01-.75.75H5.612l4.158 3.96a.75.75 0 11-1.04 1.08l-5.5-5.25a.75.75 0 010-1.08l5.5-5.25a.75.75 0 111.04 1.08L5.612 9.25H16.25A.75.75 0 0117 10z" clipRule="evenodd" />
        </svg>
      </button>

      {/* Header */}
      <header className="border-b bg-slate-50">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900">Privacy Policy</h1>
          <div className="mt-2 h-0.5 w-16 rounded-full" style={{ backgroundColor: BRAND }} />
          <p className="mt-2 text-slate-500">
            Our commitment to transparency and data protection
          </p>
        </div>
      </header>

      {/* Body */}
      <main className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <div className="grid grid-cols-1 md:grid-cols-[280px_1fr] gap-4 sm:gap-6">
          {/* Sidebar sticky */}
          <aside className="md:sticky md:top-24 self-start">
            <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-3">
              <p className="px-2 pb-2 text-[13px] font-medium text-slate-500">Quick Navigation</p>
              <nav ref={tocRef}>
                <ul className="space-y-1">
                  {SECTIONS.map(({ id, title, icon }) => (
                    <li key={id}>
                      <a
                        data-id={id}
                        href={`#${id}`}
                        aria-current="false"
                        className="
                          group relative flex items-center gap-3 rounded-lg px-3 py-2
                          text-[14px] text-slate-700 hover:bg-teal-50
                          aria-current:bg-teal-50
                        "
                      >
                        {Icons[icon](iconMenuCls)}
                        <span>{title}</span>
                        {/* barra esquerda quando hover/ativo */}
                      <span
  className="
    pointer-events-none absolute left-0 top-1 bottom-1 w-0.5 rounded
    bg-[#4CB1A1] opacity-0 transition-opacity duration-200
    group-hover:opacity-100 group-aria-current:opacity-100
  "
/>
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          </aside>

          {/* Content */}
          <div>
            <Card {...SECTIONS[0]}>
              <p>
                Invisible Cloud Lda informs the User about its Privacy Policy regarding the
                processing and protection of personal data of users and customers that may be
                collected by browsing or contracting services through https://invisiblecloud.pt. In
                this sense, Invisible Cloud Lda guarantees compliance with Regulation (EU) 2016⁄679
                (GDPR).
              </p>
              <p className="mt-3">
                The use of https://invisiblecloud.pt implies the acceptance of this privacy policy
                as well as the conditions included in the Legal Notice.
              </p>
            </Card>

            <Card {...SECTIONS[1]}>
              <p>
                <strong>Holder:</strong> Invisible Cloud Lda.<br />
                <strong>NIF/CIF:</strong> PT513796487<br />
                <strong>Address:</strong> Rua Alfredo Allen 455/461 4200-135 Porto PORTUGAL<br />
                <strong>E-mail:</strong>{" "}
                <a className={brandLinkCls} href="mailto:info@invisiblecloud.pt">
                  info@invisiblecloud.pt
                </a>
              </p>
            </Card>

            <Card {...SECTIONS[2]}>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Lawfulness, fairness and transparency:</strong> consent requested for specific purposes with absolute transparency.</li>
                <li><strong>Data minimization:</strong> we only request strictly necessary data.</li>
                <li><strong>Retention limitation:</strong> we keep data no longer than necessary and periodically delete inactive subscriptions.</li>
                <li><strong>Integrity & confidentiality:</strong> we take precautions to avoid unauthorized access or misuse.</li>
              </ul>
            </Card>

            <Card {...SECTIONS[3]}>
              <p>
                Browsing https://link.invisiblecloud.pt does not require personal data. If you download materials and provide contact info accepting marketing subscription, we may contact you directly.
              </p>
            </Card>

            <Card {...SECTIONS[4]}>
              <p>
                You may request: access, rectification, deletion, processing limitation, opposition and portability. Exercise is personal and must be requested directly to Invisible Cloud Lda.
              </p>
              <p className="mt-3">
                Email{" "}
                <a className={brandLinkCls} href="mailto:link@invisiblecloud.pt">
                  link@invisiblecloud.pt
                </a>{" "}
                with valid proof of identity. You also have judicial protection and may complain to the relevant supervisory authority.
              </p>
            </Card>

            <Card {...SECTIONS[5]}>
              <p>
                When you email, subscribe or contract via https://invisiblecloud.pt you provide personal info (IP, name, address, email, phone…). By providing it, you consent to collection and processing by Invisible Cloud Lda as in the Legal Notice and this Policy.
              </p>
              <ul className="list-disc pl-6 mt-3 space-y-2">
                <li>Ensure compliance with terms and law; build tools to preserve confidentiality.</li>
                <li>Support and improve services offered on the site.</li>
                <li>Collect non-identifying data via cookies (see Cookies Policy).</li>
                <li>
                  Manage social networks (
                  <a className={brandLinkCls} href="https://www.facebook.com/invisiblecloudlda/">Facebook</a>,{" "}
                  <a className={brandLinkCls} href="https://x.com/InviCloud">Twitter</a>,{" "}
                  <a className={brandLinkCls}  href="https://pt.linkedin.com/company/invisible-cloud">LinkedIn</a>
                  ) under their policies.
                </li>
              </ul>
            </Card>

            <Card {...SECTIONS[6]}>
              <p>
                Your data may be added to a mailing list we manage. We take reasonable precautions and best practices to avoid loss, misuse, unauthorized access, disclosure, alteration or destruction.
              </p>
            </Card>

            <Card {...SECTIONS[7]}>
              <p>
                For https://invisiblecloud.pt to work correctly, cookies are used (stored in your browser). See the Cookies Policy.
              </p>
            </Card>

            <Card {...SECTIONS[8]}>
              <p><strong>Legal basis:</strong> consent; to contact or comment you must accept this policy.</p>
              <p className="mt-2"><strong>Categories:</strong> identification data; no special categories processed.</p>
              <p className="mt-2"><strong>Retention:</strong> until deletion is requested by the data subject.</p>
            </Card>

            <Card {...SECTIONS[9]}>
              <p>
                Google/partners may use cookies for ads/analytics. Google Analytics may store info (incl. IP) on US servers per Google’s privacy policy.
              </p>
              <p className="mt-3">
                Non-identifying data may be collected during browsing (IP, approximate location, usage logs, habits) via third-party services.
              </p>
            </Card>

            <Card {...SECTIONS[10]}>
              <p>
                You are solely responsible for accuracy of data provided and agree to keep them updated and complete. You accept and consent to processing as stated in this policy.
              </p>
              <p className="mt-3">
                You may revoke consent or exercise rights at{" "}
                <a className={brandLinkCls} href="mailto:info@invisiblecloud.pt">
                  info@invisiblecloud.pt
                </a>. This excludes data we must keep for administrative, legal or security reasons.
              </p>
            </Card>

            <Card {...SECTIONS[11]}>
              <p>
                Invisible Cloud Lda may modify this policy to adapt to legislation, jurisprudence or industry practices. It remains in force until replaced by a duly published update.
              </p>
            </Card>

            <Card {...SECTIONS[12]}>
              <p>
                Our website address is{" "}
                <a className={brandLinkCls} href="https://invisiblecloud.pt">
                  https://invisiblecloud.pt
                </a>.
              </p>
            </Card>

            <Card {...SECTIONS[13]}>
              <p>
                We may collect form data, IP and user-agent for spam detection. A hash of your email may be sent to Gravatar to check usage (see Automattic Privacy Policy). After approval, your profile image can be public in the context of your comment.
              </p>
            </Card>

            <Card {...SECTIONS[14]}>
              <p>Comments you leave may display your profile image publicly once approved.</p>
            </Card>

            <Card {...SECTIONS[15]}>
              <p>If you upload images, avoid EXIF GPS data; visitors can extract location data from images.</p>
            </Card>

            <Card {...SECTIONS[16]}>
              <p>
                Convenience cookies can store your name/email/site for one year. Temporary cookie checks if your browser accepts cookies. Login sets cookies for session and display options; “Remember me” lasts two weeks; logout clears login cookies. Editing/publishing stores a 1-day cookie with the post ID.
              </p>
            </Card>

            <Card {...SECTIONS[17]}>
              <p>
                Embedded content behaves as if you visited the external site and may collect data, use cookies, include third-party tracking and monitor your interaction.
              </p>
            </Card>

            <Card {...SECTIONS[18]}>
              <p>
                If you leave a comment, we retain it and metadata indefinitely to recognise/approve follow-ups automatically. Registered users can view/edit/delete their data (except username). Admins can also view/edit it.
              </p>
            </Card>

            <Card {...SECTIONS[19]}>
              <p>
                If you have an account or left comments, you may request an export of your personal data and request deletion (except data we must retain for admin, legal or security purposes).
              </p>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
